import { styled } from '@linaria/react';

import { MqDesktop, MqTablet } from '~theme/media';

export const CommonInnerNav = `
	display: flex;
	pointer-events: auto;
	gap: 10px;

	${MqDesktop} {
		gap: 14px;
	}
`;

export const LeftContent = styled.div`
	display: flex;
	align-items: center;

	${MqTablet} {
		width: 30%;
	}
`;

export const LeftContentInner = styled.nav`
	${CommonInnerNav}
	padding: 5px 0 3px 8px;
`;

export const MiddleContent = styled.div`
	display: flex;
	flex-grow: 1;
	align-items: center;
	justify-content: center;
`;
export const MiddleContentInner = styled.nav`
	${CommonInnerNav}
	display: none;
	padding: 4px;
	border-radius: var(--radius-xl);
	background-color: var(--color-grey-6-solid);
	gap: var(--gap-s);
	${MqTablet} {
		display: flex;
	}
`;
